import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

export const AutoTagsFiltersBar: FC<{
  loading: boolean
  query: string
  onQuery: (v: string) => void
  mode: "" | "BATCH" | "REALTIME"
  onMode: (v: "" | "BATCH" | "REALTIME") => void
  onlyActive: boolean
  onOnlyActive: (v: boolean) => void
  tagId: string
  onTagId: (v: string) => void
  tagOptions: { id: string; name: string }[]
  onRefresh: () => void
  onRunBatch: () => void
  onCreate: () => void
}> = ({ loading, query, onQuery, mode, onMode, onlyActive, onOnlyActive, tagId, onTagId, tagOptions, onRefresh, onRunBatch, onCreate }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const inputCls = clsx(
    "input input-bordered w-full md:w-[240px]",
    "bg-white dark:bg-[#0C0C1A]",
    "text-black dark:text-white",
    "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
  )

  const selectCls = clsx(
    "select select-bordered w-full md:w-[160px]",
    "bg-white dark:bg-[#0C0C1A]",
    "text-black dark:text-white",
    "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
  )

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:flex-wrap">
      <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center">
        <input
          className={inputCls}
          placeholder={t("tags.searchByRuleName") as string}
          value={query}
          onChange={(e) => onQuery(e.target.value)}
        />

        <select className={selectCls} value={mode} onChange={(e) => onMode(e.target.value as any)}>
          <option value="">{t("form.allModes")}</option>
          <option value="BATCH">BATCH</option>
        </select>

        <select className={selectCls} value={tagId} onChange={(e) => onTagId(e.target.value)}>
          <option value="">{t("tags.allAutoTags")}</option>
          {tagOptions.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>

        <label className="flex items-center gap-2 text-sm text-black dark:text-white">
          <input type="checkbox" className="checkbox checkbox-sm" checked={onlyActive} onChange={(e) => onOnlyActive(e.target.checked)} />
          {t("tags.activeOnly")}
        </label>
      </div>

      <div className="flex gap-2">
        <button className={clsx("btn btn-sm", { "btn-disabled": loading })} onClick={onRefresh}>
          {t("common.refresh")}
        </button>
        <button className={clsx("btn btn-sm btn-outline", { "btn-disabled": loading })} onClick={onRunBatch}>
          {t("tags.runBatch")}
        </button>
        <button className="btn btn-sm btn-primary" onClick={onCreate}>
          {t("tags.newAutomaticTag")}
        </button>
      </div>
    </div>
  )
}
